var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Rect from "@reach/rect";
import FocusTrap from "focus-trap-react";
import { IconDropdown } from "@wrstudios/icons";
import Portal from "../portal/Portal";
import UserAvatar from "../user-avatar/UserAvatar";
import { Container, MenuButton, NameAndCompany, DropdownArrowLayout, MenuContainer, MenuSection, PhoneLabel, TelLink, ButtonLink } from "./styled/agent-info-dropdown";
var AgentInfoDropdown = /** @class */ (function (_super) {
    __extends(AgentInfoDropdown, _super);
    function AgentInfoDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isOpen: false };
        _this.handleKeyDown = function (e) {
            switch (e.key) {
                case "ArrowDown":
                case "ArrowUp":
                    if (!_this.state.isOpen) {
                        _this.setState({ isOpen: true });
                    }
                    break;
                default:
                    return;
            }
        };
        _this.toggleMenu = function () {
            _this.setState(function (_a) {
                var isOpen = _a.isOpen;
                return ({ isOpen: !isOpen });
            });
        };
        return _this;
    }
    AgentInfoDropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, isAuthed = _a.isAuthed, hasCompleteAddress = _a.hasCompleteAddress, hasPhoneNumber = _a.hasPhoneNumber, firstName = _a.firstName, _b = _a.initials, initials = _b === void 0 ? "" : _b, initialsColor = _a.initialsColor, avatar = _a.avatar, name = _a.name, email = _a.email, company = _a.company, address = _a.address, city = _a.city, state = _a.state, zip = _a.zip, phone = _a.phone, officePhone = _a.officePhone, zIndex = _a.zIndex;
        if (!isAuthed)
            return null;
        return (React.createElement(Rect, null, function (_a) {
            var rect = _a.rect, ref = _a.ref;
            return (React.createElement(Container, { onKeyDown: _this.handleKeyDown },
                React.createElement(MenuButton, { onClick: _this.toggleMenu, ref: ref },
                    React.createElement(UserAvatar, { initials: initials, initialsColor: initialsColor, avatarUrl: avatar, size: "xs" }),
                    React.createElement(NameAndCompany, null,
                        name && React.createElement("strong", null, name),
                        company && React.createElement("span", null, company)),
                    React.createElement(DropdownArrowLayout, { isOpen: _this.state.isOpen },
                        React.createElement(IconDropdown, null))),
                _this.state.isOpen && (React.createElement(Portal, null,
                    React.createElement(FocusTrap, { focusTrapOptions: {
                            onDeactivate: _this.toggleMenu,
                            clickOutsideDeactivates: true,
                            initialFocus: "#menu"
                        } },
                        React.createElement(MenuContainer, { id: "menu", tabIndex: -1, style: {
                                top: ((rect === null || rect === void 0 ? void 0 : rect.top) || 0) + ((rect === null || rect === void 0 ? void 0 : rect.height) || 0) + 10,
                                left: ((rect === null || rect === void 0 ? void 0 : rect.left) || 0) - 10
                            }, zIndex: zIndex },
                            React.createElement(MenuSection, null,
                                name && React.createElement("strong", null, name),
                                company && React.createElement("span", null, company)),
                            hasCompleteAddress && (React.createElement(MenuSection, null,
                                React.createElement("span", null, address),
                                React.createElement("span", null,
                                    city,
                                    ", ",
                                    state,
                                    " ",
                                    zip))),
                            hasPhoneNumber && (React.createElement(MenuSection, null,
                                officePhone && (React.createElement(TelLink, { href: "tel:" + officePhone },
                                    React.createElement(PhoneLabel, null, "Office:"),
                                    React.createElement("span", null, officePhone))),
                                phone && (React.createElement(TelLink, { href: "tel:" + phone },
                                    React.createElement(PhoneLabel, null, "Phone:"),
                                    React.createElement("span", null, phone))))),
                            React.createElement(MenuSection, null,
                                React.createElement(ButtonLink, { href: "mailto:" + email },
                                    "Email", " " + firstName))))))));
        }));
    };
    return AgentInfoDropdown;
}(Component));
export default AgentInfoDropdown;
